<!--单位信息模块-->
<template>
  <div class="powerValueViewBody">
    <div class="dayMonth">
      <div class="usePowerUnitBlock" style="width: 10%;" v-for="(item,index) in electricAnalyze" :key="index">
        <p class="usePowerUnitBoxTitle">{{item.name}}</p>
        <p :class="{'usePowerUnitBoxInfo':true,'special':index == 0}">{{item.value}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import resourcesStore from '@/cache/resourcesStore.js'
  import request from "@/api/http.js";
  export default {
    components: {},
    props: ['state'],
    data () {
      return {
        electricAnalyze1: [{
          name: "今年总耗水量",
          value: '-',
        },
        {
          name: "今日水耗",
          value: '-',
          safe: 1,
        },
        {
          name: "昨日水耗",
          value: '-',
          safe: 1,
        },
        {
          name: "上月同期",
          value: '-',
          safe: 1,
        },
        {
          name: "本月水耗",
          value: '-',
          safe: 0,
        },
        {
          name: "上月水耗",
          value: '-',
          safe: 0,
        },
        {
          name: "去年同期",
          value: '-',
          safe: 0,
        }],
        electricAnalyze2: [{
          name: "今年总耗电量",
          value: '0',
        },
        {
          name: "今日电耗",
          value: '0',
          safe: 1,
        },
        {
          name: "昨日电耗",
          value: '0',
          safe: 1,
        },
        {
          name: "上月同期",
          value: '0',
          safe: 1,
        },
        {
          name: "本月电耗",
          value: '0',
          safe: 0,
        },
        {
          name: "上月电耗",
          value: '0',
          safe: 0,
        },
        {
          name: "去年同期",
          value: '114594.41',
          safe: 0,
        }],
        electricAnalyze: [],
        yearPowerValue: undefined,
        day1: undefined, //今日
        day2: undefined, //上月同期
        day3: undefined, //昨日同期
        month1: undefined,
        month2: undefined,
        month3: undefined, //去年同期
        monthEvent: 0,
      }
    },
    created () {},
    mounted () {
      this.getPowerValue(this.nowUnit.id)
    },
    destroyed () {},
    computed: {
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName
      },
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
      day2Compare () {
        return this.compareValue(this.day1,this.day2)
      },
      day3Compare () {
        return this.compareValue(this.day1,this.day3)
      },
      month2Compare () {
        return this.compareValue(this.month1,this.month2)
      },
      month3Compare () {
        return this.compareValue(this.month1,this.month3)
      },
      getImagePath () {
        return value => {
          if(value=='--'||value==0) {
            return ''
          }
          return value>0? this.getResourcesByName('unitInfo/up.png'):this.getResourcesByName('unitInfo/down.png')
        }
      },
      loadCapacity () {
        //总负荷容量
        var count=0
        for(var i=0,len=this.loadDeviceList.length;i<len;i++) {
          var item=this.loadDeviceList[i]
          var info=this.deviceNoToArchivesInfo[item.deviceno]
          if(!isempty(info)&&!isempty(info.next)) {
            var target=info.next.find(it => it.propertyCode="Capacity")
            if(!isempty(target)&&!isempty(target.value)) {
              try {
                count+=parseFloat(target.value)
              } catch(e) {}
            }
          }
        }
        return parseInt(count)
      },
    },
    watch: {
      nowUnit (nv,ov) {
        this.getPowerValue(nv.id)
      },
      unitDeviceList (nv,ov) {
        this.getMonthPowerTop(nv)
      }
    },
    methods: {
      compareValue (a,b) {
        if(a==0||b==0||a==undefined||b==undefined) {
          return "--"
        }
        return cutDigital((a-b)/b*100)+"%"
      },
      // getPowerValue (unitId) {
      //   if(isempty(unitId)) {
      //     return
      //   }
      //   var now=new Date()
      //   var nowTime=now.getTime()
      //   var year=now.getFullYear()
      //   var month=now.getMonth()
      //   var day=now.getDate()
      //   var nowZero=new Date(year,month,day).getTime()
      //   //获取今年用电量
      //   this.$api.powerApi.getUnitUsePowerByDate(unitId,new Date(year,0,1).getTime(),nowTime,respon => {
      //     this.yearPowerValue=Number(respon)
      //     if(month==0) {
      //       this.month1=Number(respon)
      //     }
      //   })
      //   //获取今日电量
      //   this.$api.powerApi.getUnitUsePowerByDate(unitId,nowZero,nowTime,respon => {
      //     this.day1=Number(respon)
      //     //把今日电耗传入父组件
      //     this.$emit('child-event',this.day1);
      //     if(day==1) {
      //       this.month1=Number(respon)
      //     }
      //   })
      //   //获取昨日电量
      //   this.$api.powerApi.getUnitUsePowerByDate(unitId,nowZero-24*60*60*1000,nowZero-1,respon => {
      //     this.day2=Number(respon)
      //   })
      //   //获取上个月同一天用电量，直接月份减1如果不存在就是空
      //   var lastMonthDate=new Date(year,month-1,day)

      //   //if(lastMonthDate.getMonth() + 1 != 12 && lastMonthDate.getMonth() + 1 != 1) {
      //   this.$api.powerApi.getUnitUsePowerByDate(unitId,lastMonthDate.getTime(),lastMonthDate.getTime()+24*60*60*
      //     1000-1,respon => {


      //       this.day3=Number(respon)
      //     })
      //   // } else {
      //   // 	this.day3 = undefined
      //   // }
      //   //获取本月用电量
      //   this.$api.powerApi.getUnitUsePowerByDate(unitId,new Date(year,month,1).getTime(),nowTime,respon => {
      //     this.month1=Number(respon)
      //   })
      //   //获取上月用电量
      //   this.$api.powerApi.getUnitUsePowerByDate(unitId,new Date(year,month-1,1).getTime(),new Date(year,month-1,31)
      //     .getTime()-
      //     1,respon => {
      //       this.month2=Number(respon)
      //     },repon => {
      //       this.month2=undefined
      //     })
      //   //获取去年同月用电量
      //   this.$api.powerApi.getUnitUsePowerByDate(unitId,new Date(year-1,month,1).getTime(),new Date(this.getLastDay(
      //     year-1,month+1)).getTime(),respon => {
      //       this.month3=Number(respon)
      //     },respon => {
      //       this.month3=undefined
      //     })
      // },
      // 获取水量
      getPowerValue2 (unitId) {
        if(isempty(unitId)) {
          return
        }
        console.log(unitId,'获取水量');
        var now=new Date()
        var nowTime=now.getTime()
        var year=now.getFullYear()
        var month=now.getMonth()
        var day=now.getDate()
        var nowZero=new Date(year,month,day).getTime()

        var params={
          bgTime: new Date(year,0,1).getTime(),
          endTime: nowTime,
          unitId: unitId,
        }
        //获取今年用水量
        request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {

          if(res.code=200) {
            this.electricAnalyze1[0].value=Number(res.data);
          }
        })


        //获取今日水量 
        var params={
          bgTime: nowZero,
          endTime: nowTime,
          unitId: unitId,
        }
        request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {
          if(res.code=200) {
            this.electricAnalyze1[1].value=Number(res.data);
          }
        })

        //获取昨日水量
        var params={
          bgTime: nowZero-24*60*60*1000,
          endTime: nowZero-1,
          unitId: unitId,
        }
        request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {
          if(res.code=200) {
            this.electricAnalyze1[2].value=Number(res.data);
          }
        })


        // 获取上个月同一天用水量，直接月份减1如果不存在就是空
        var lastMonthDate=new Date(year,month-1,day)
        var params={
          bgTime: lastMonthDate.getTime(),
          endTime: lastMonthDate.getTime()+24*60*60*1000-1,
          unitId: unitId,
        }
        request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {
          if(res.code=200) {
            this.electricAnalyze1[3].value=Number(res.data);
          }
        })

        // 获取本月用水量
        var params={
          bgTime: new Date(year,month,1).getTime(),
          endTime: nowTime,
          unitId: unitId,
        }
        request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {
          if(res.code=200) {
            this.electricAnalyze1[4].value=Number(res.data);
          }
        })

        //获取上月用水量 
        var params={
          bgTime: new Date(year,month-1,1).getTime(),
          endTime: new Date(year,month,1).getTime()-1,
          unitId: unitId,
        }
        request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {
          if(res.code=200) {
            this.electricAnalyze1[5].value=Number(res.data);
          }
        })

        // 获取去年同月用水量
        var params={
          bgTime: new Date(year-1,month,1).getTime(),
          endTime: new Date(this.getLastDay(year-1,month+1)).getTime(),
          unitId: unitId,
        }
        request({url: "/cost/getUnitWaterPowerByDate.do",method: "get",params}).then(res => {
          if(res.code=200) {
            this.electricAnalyze1[6].value=Number(res.data);
            setTimeout(() => {
              this.electricAnalyze=this.electricAnalyze1
            },200);
          }
        })
      },
      getPowerValue (unitId) {
        if(isempty(unitId)) {
          return
        }
        console.log(unitId,'111111');
        if(this.state==1) {
          this.electricAnalyze=this.electricAnalyze1;
          this.getPowerValue2(unitId);
          return
        } else {
          this.electricAnalyze=this.electricAnalyze2;
        }
        var now=new Date()
        var nowTime=now.getTime()
        var year=now.getFullYear()
        var month=now.getMonth()
        var day=now.getDate()
        var nowZero=new Date(year,month,day).getTime()
        //获取今年用电量
        this.$api.powerApi.getUnitUsePowerByDate(unitId,new Date(year,0,1).getTime(),nowTime,respon => {
          this.electricAnalyze[0].value=Number(respon)
        })
        //获取今日电量
        this.$api.powerApi.getUnitUsePowerByDate(unitId,nowZero,nowTime,respon => {
          this.electricAnalyze[1].value=Number(respon)
        })
        //获取昨日电量
        this.$api.powerApi.getUnitUsePowerByDate(unitId,nowZero-24*60*60*1000,nowZero-1,respon => {
          this.electricAnalyze[2].value=Number(respon)
        })
        // 获取上个月同一天用电量，直接月份减1如果不存在就是空
        var lastMonthDate=new Date(year,month-1,day)
        this.$api.powerApi.getUnitUsePowerByDate(unitId,lastMonthDate.getTime(),lastMonthDate.getTime()+24*60*60*
          1000-1,respon => {
            this.electricAnalyze[3].value=Number(respon);

            // 本月电耗
            var aa=new Date(year,month,1).getTime();
            this.$api.powerApi.getUnitUsePowerByDate(unitId,aa,nowTime,respon => {
              this.electricAnalyze[4].value=Number(respon)
            })
          })

        //获取上月用电量
        var timestamp=new Date(year,month-1,1).getTime();
        var timestamp2=new Date(year,month,1).getTime()-1;
        this.$api.powerApi.getUnitUsePowerByDate(unitId,timestamp,timestamp2,respon => {
          this.electricAnalyze[5].value=Number(respon)
        })
        //获取上月用电量
        // this.$api.powerApi.getUnitUsePowerByDate(unitId, new Date(year, month - 1, 1).getTime(), new Date(year, month, day)
        // 	.getTime() -
        // 	1, respon => {
        // 		this.electricAnalyze[5].value = Number(respon)
        // 	})
        // 获取去年同月用电量
        this.$api.powerApi.getUnitUsePowerByDate(unitId,new Date(year-1,month,1).getTime(),new Date(this.getLastDay(
          year-1,month+1)).getTime(),respon => {
            this.electricAnalyze[6].value=Number(respon)
          })
      },
      getLastDay (year,month) {
        var new_year=year; //取当前的年份          
        var new_month=month++; //取下一个月的第一天，方便计算（最后一天不固定）          
        if(month>12) {
          new_month-=12; //月份减          
          new_year++; //年份增          
        }
        var new_date=new Date(new_year,new_month,1); //取当年当月中的第一天          
        return year+'-'+new_month+'-'+(new Date(new_date.getTime()-1000*60*60*24)).getDate(); //获取当月最后一天日期          
      }
    }
  }
</script>

<style scoped>
  @import url("../../../components/css/usePowerUnit.css");

  .dayMonth {
    width: 100%;
    height: 90%;
    display: flex;
    flex: 1;
    justify-content: space-around;
    align-items: center;
  }
</style>